<template>
    <div class="media-card" @click="onEventClick({ eventId: video.eventId, hardwareId: video.hardwareId })">
        <div class="media-card__video">
            <icon class="media-card__video-icon" icon="video"/>
            Requested On: {{ date(video.createdOn) }}
        </div>
        <div class="media-card__details">
            <div class="media-card__date">{{ date(video.dateRequested) }}</div>
            <div class="media-card__status">{{ getMediaStatus(video.state) }}</div>
        </div>
        <div class="media-card__details">
            <div class="media-card__car">{{ video.driverName || 'Any' }} / {{ video.vehicleRegistrationNumber || 'Unknown' }}</div>
        </div>
    </div>
</template>

<script>

import { formatDate, searchEnumById } from '@/helpers/Utils'
import Icon from '@/components/atoms/Icon'
import Plug from '@/components/atoms/Plug'
import { mapGetters } from "vuex";

export default {
    name: 'NoImageVideoItem',
    components: { Icon, Plug },
    props: {
        video: {
            type: Object,
            required: true
        },
        onEventClick: {
            type: Function,
            required: false
        }
    },
    computed: {
        ...mapGetters({
            getEventTypes: 'dictionaryModule/getEventTypes',
            getDeviceCommandStates: 'dictionaryModule/getDeviceCommandStates',
        }),
    },
    methods: {
        date (date) {
            return formatDate(date)
        },
        getMediaStatus (status) {
            return searchEnumById(this.getDeviceCommandStates, status)
        }
    }
}
</script>

<style scoped lang="scss">

.media-card {
    box-shadow: 0 2px 9px #b0b0b0;
    transition: border 0.3s;
    cursor: pointer;
    border: 1px solid transparent;
    border-bottom: 2px solid transparent;
    padding: 12px 6px 6px 6px;
    &:hover {
        border: 1px solid $secondary-default;
        border-bottom: 2px solid $secondary-default;
    }

    &__video {
        display: flex;
        align-items: center;
        color: $secondary-default;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 6px;

        &:hover {
            color: $primary-default;
            cursor: pointer;
        }
    }

    &__video-icon {
        margin-right: 10px;
    }

    &__details {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 400;
        padding-bottom: 7px;
    }
    &__date {
        color: $primary-default;
        font-weight: bold;
    }

    &__status {
        font-weight: bold;
        text-transform: uppercase;
    }

}

</style>
